import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sister-ship-popup',
  templateUrl: './sister-ship-popup.component.html',
  styleUrls: ['./sister-ship-popup.component.scss']
})
export class SisterShipPopupComponent {
vesselName: string = '';
  vesselIMO: string = '';

  constructor(public dialogRef: MatDialogRef<SisterShipPopupComponent>) {}

  onSubmit(submit: boolean): void {
    if (submit) {
      this.dialogRef.close({
        vesselName: this.vesselName,
        vesselIMO: this.vesselIMO
      });
    } else {
      this.dialogRef.close();
    }
  }
}
